import React, { useState } from "react";

import css from "./OrderDetailsRight.module.css";
import { OrderInfoClientSingleDateDishes } from "../index";
import { Button, Popconfirm, message } from "antd";
import { ordersService } from "../../../../services/orders-services";
import { useDispatch } from "react-redux";
import { ordersActions } from "../../../../store/slices/orders-slices";
import { ReloadOutlined } from "@ant-design/icons";

const OrderDetailsRight = ({
  dishes,
  order,
  setIsShowCancellation,
  totalCost,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [messageApi, holder] = message.useMessage();

  const handleResetOrderMeals = async () => {
    try {
      setIsLoading(true);
      await ordersService.resetOrderMeals(order.id);
      messageApi.success("Order meals reset successfully");
      dispatch(ordersActions.changeTrigger());
    } catch (error) {
      messageApi.error("Failed to reset order meals");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={css.wrap}>
      {holder}
      <div className={css.actionButtons}>
        <div className={css.totalCost}>Total Cost: {totalCost.toFixed(2)}</div>
        <Popconfirm
          title="Are you sure to reset order meals?"
          description="This action will reset all order meals for the selected dates."
          onConfirm={() => handleResetOrderMeals()}
          okText="Yes"
          cancelText="No"
        >
          <Button type="primary" loading={isLoading} icon={<ReloadOutlined />}>
            Reset Order Meals
          </Button>
        </Popconfirm>
      </div>
      {dishes &&
        dishes.map((obj) => (
          <OrderInfoClientSingleDateDishes
            key={obj.date}
            obj={obj}
            order={order}
            setIsShowCancellation={setIsShowCancellation}
          />
        ))}
    </div>
  );
};

export default React.memo(OrderDetailsRight);
